import * as React from "react";

import {
  Box,
  Slide,
  Stack,
  DialogContent,
  Dialog,
  Divider,
  Typography,
  Avatar,
  IconButton,
  Button,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  fullName,
  getUserId,
  isOwnerId,
  kFormatter,
} from "../../constants/function";
import NoData from "./../../components/Nodata";
import { Images } from "../../assets/common";
import NftList from "../DirectChat/nftList";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import { useTranslation } from "react-i18next";
import { SocketContext } from "../../context/socket";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TopListPopup({
  open,
  handleClose,
  image,
  data,
  error,
  isTip,
  isArray,
  title,
  isLiveUser,
  isUsers,
  onTipPoupOpen,
  onNftPoupOpen,
  onRequestToHost,
  isOwner,
  onHandleMute,
  onToggleCamera,
  channelName,
  followings,
  obs,
}) {
  const { t } = useTranslation("common");
  const [index, setIndex] = React.useState(null);

  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose()}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#262626",
            boxShadow: "none",

            borderRadius: "4px",
            padding: 0,
            width: "444px",
            height: "auto",
          },
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          padding="20px"
          sx={{ backgroundColor: "#262626" }}
        >
          {title ? (
            <Typography className="fs-19">{title}</Typography>
          ) : (
            <Stack direction="row" alignItems="center" gap="5px">
              <img src={image} alt="icon" />
              <Typography className="fs-19">
                {isTip ? t("topListPopup.title1") : t("topListPopup.title2")}
              </Typography>
            </Stack>
          )}

          <CloseOutlinedIcon
            className="_cp"
            onClick={() => handleClose()}
            color="default"
          />
        </Stack>
        <Divider color="#262626" />
        <DialogContent sx={{ backgroundColor: "#262626" }}>
          <Stack spacing={1}>
            {!isLiveUser && !isUsers && data && data.length > 0 ? (
              data.map((m, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <Avatar
                    src={m["profileImg"] ? m["profileImg"]["filePath"] : null}
                  />
                  <Stack>
                    <Typography className="fs-15 _cp">{fullName(m)}</Typography>
                    <Typography className="fs-13">
                      {kFormatter(m["followers"])} {t("topListPopup.text1")}
                    </Typography>
                  </Stack>
                </Stack>
              ))
            ) : isLiveUser && !isUsers && data && data.length > 0 ? (
              data.map((m, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <Avatar
                    src={m["profilePic"] ? m["profilePic"]["filePath"] : null}
                  />
                  <Stack>
                    <Typography className="fs-15">{m["fullName"]}</Typography>
                  </Stack>
                </Stack>
              ))
            ) : isUsers && data && data.length > 0 ? (
              data.map((m, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <Avatar
                    src={m?.user?.profileImg?.filePath || Images.default_user}
                  />
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    sx={{ width: "100%" }}
                  >
                    <Typography className="fs-15">
                      {fullName(m?.user)}
                    </Typography>
                    {isOwnerId(m?.user?._id) ? null : (
                      <img
                        title="Tip"
                        onClick={() => onTipPoupOpen(m?.user)}
                        style={{ width: "24px", cursor: "pointer" }}
                        src={Images.tipOwner}
                        alt=""
                      />
                    )}
                    {/* TODO: compressed for now*/}
                    {/* {isOwnerId(m?.user?._id) ? null : (
                      <img
                        title="gift nft"
                        onClick={() => {
                          onNftPoupOpen(m.user);
                        }}
                        style={{ width: "24px", cursor: "pointer" }}
                        src={Images.GIFT}
                        alt=""
                      />
                    )} */}
                    {!isOwner ? null : obs ? null : isOwnerId(
                        m?.user?._id
                      ) ? null : m?.user?.role === "audience" ? (
                      <IconButton
                        title="Make co-host"
                        onClick={() =>
                          onRequestToHost(m?.user._id, index, m?.user)
                        }
                      >
                        <GroupAddIcon
                          sx={{ width: "24px" }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    ) : (
                      <IconButton
                        title="Make audience"
                        onClick={() =>
                          onRequestToHost(m?.user._id, index, m?.user)
                        }
                      >
                        <GroupRemoveIcon
                          sx={{ width: "24px" }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    )}
                    {/* NOTE commented for now */}
                    {isOwnerId(m?.user?._id) ? null : (
                      <StreamFollow
                        channelName={channelName}
                        followings={followings}
                        _id={m?.user?._id}
                      />
                    )}
                    {/* Mue unmute camera */}
                    {/* {!isOwner ? null : isOwnerId(m?.user?._id) ? null : m?.user
                        ?.role === "host" && m?.user?.camera === false ? (
                      <IconButton onClick={() => onToggleCamera(m?.user, true)}>
                        <VideocamOffIcon
                          sx={{
                            width: "24px",
                            cursor:
                              m?.user?.mutedBy === "host"
                                ? "not-allowed"
                                : "pointer",
                            color:
                              m?.user?.mutedBy === "host"
                                ? "#ffffff !important"
                                : "grey !important",
                          }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    ) : m?.user?.role === "host" && m?.user?.camera === true ? (
                      <IconButton
                        onClick={() => onToggleCamera(m?.user, false)}
                      >
                        <VideocamIcon
                          sx={{ width: "24px" }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    ) : null} */}
                    {/* mute/unmute mic */}
                    {/* {!isOwner ? null : isOwnerId(m?.user?._id) ? null : m?.user
                        ?.role === "host" && m?.user?.mic === false ? (
                      <IconButton
                        onClick={() =>
                          m?.user?.mutedBy === "host"
                            ? onHandleMute(m?.user)
                            : console.log("")
                        }
                      >
                        <MicOffIcon
                          sx={{
                            width: "24px",
                            cursor:
                              m?.user?.mutedBy === "host"
                                ? "not-allowed"
                                : "pointer",
                            color:
                              m?.user?.mutedBy === "host"
                                ? "#ffffff !important"
                                : "grey !important",
                          }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    ) : m?.user?.role === "host" && m?.user?.mic === true ? (
                      <IconButton onClick={() => onHandleMute(m?.user)}>
                        <MicIcon
                          sx={{ width: "24px" }}
                          color="default"
                          className="_cp"
                        />
                      </IconButton>
                    ) : null} */}
                  </Stack>
                </Stack>
              ))
            ) : (
              <Box sx={{ position: "relative" }}>
                <NoData lable={t("noData.noData")} />
              </Box>
            )}
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export function StreamFollow({ followings, _id, channelName }) {
  const { t } = useTranslation("common");
  const socket = React.useContext(SocketContext).Socket;
  const isFollow = followings.filter((follower) => follower === _id);
  const userId = getUserId();
  const handleFollow = () => {
    if (socket) {
      socket.emit("follow", {
        _id: userId,
        following: _id,
        channelName: channelName,
        status: isFollow.length > 0 ? false : true,
      });
    }
  };
  return (
    <Button
      sx={{
        minWidth: "100px",
        height: "28px !important",
        fontSize: "13px !important",
        marginLeft: "auto !important",
      }}
      variant={isFollow.length > 0 ? "contained" : "outlined"}
      color={isFollow.length > 0 ? "primary" : "default"}
      onClick={handleFollow}
    >
      {isFollow.length > 0
        ? t("follow.followList.button2")
        : t("follow.followList.button1")}
    </Button>
  );
}
